export { default } from './FormEventPlaces.vue'
